import axios from "axios";
import { withClientHeaders } from "@/utils/clientHeaders";

const openApiInstance = axios.create({
  baseURL: process.env.VUE_APP_OPEN_SERVERURL,
});

// 화면 위치 헤더(W6 E1) — open-api 는 허용 헤더를 목록으로 막지 않음
openApiInstance.interceptors.request.use(withClientHeaders);

export default openApiInstance;